module.exports = __webpack_public_path__ + "img/58.f90c5e2c.jpg";